export default {
    getHeaderFieldsDE: state => state.headerFieldsDE,
    getFormActionsDE: state => state.formActionsDE,
    getActionsDE: state => state.actionsDE,
    getRowActionsDE: state => state.rowActionsDE,
    isFormOpen: state => state.formIsOpen,
    isGridOpen: state => state.gridIsOpen
}
